module.exports = __webpack_public_path__ + "static/media/hoodie.e56702e7.jpg";